"use client"

import { Box, Text, VStack } from "@chakra-ui/react"
import { useState } from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import CommentForm from "@/components/Comments/CommentForm"
import CommentList from "@/components/Comments/CommentList"

interface CommentsSectionProps {
  postId: string
  onCommentCountChange?: (count: number) => void
}

const CommentsSection = ({
  onCommentCountChange,
  postId,
}: CommentsSectionProps) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleCommentSubmitted = () => {
    // Trigger a refresh of the comments list
    setRefreshTrigger((prev) => prev + 1)
  }

  const recaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY

  if (!recaptchaSiteKey) {
    return (
      <Box bg="red.50" borderRadius="md" borderWidth={1} p={4}>
        <Text color="red.600">
          reCAPTCHA is not configured. Please add RECAPTCHA_SITE_KEY to your
          environment variables.
        </Text>
      </Box>
    )
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      <VStack
        alignItems="stretch"
        borderBottom={"1px solid {colors.border}"}
        gap={0}
        w="full"
      >
        <VStack
          align="stretch"
          bg={"bg.paper"}
          borderLeft={"1px solid {colors.border}"}
          borderRight={"1px solid {colors.border}"}
          gap={0}
          id="comments"
          maxW="8xl"
          mx="auto"
          w="full"
        >
          <CommentForm
            onCommentSubmitted={handleCommentSubmitted}
            postId={postId}
          />
        </VStack>

        <VStack
          align="stretch"
          bg={"bg.paper"}
          borderLeft={"1px solid {colors.border}"}
          borderRight={"1px solid {colors.border}"}
          gap={0}
          id="comments"
          maxW="8xl"
          mx="auto"
          w="full"
        >
          <CommentList
            onCommentCountChange={onCommentCountChange}
            postId={postId}
            refreshTrigger={refreshTrigger}
          />
        </VStack>
      </VStack>
    </GoogleReCaptchaProvider>
  )
}

export default CommentsSection
